import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export function streamTableExport(graph, graphName, econVars) {
                let presave_elements = graph.getElements()
                // Here we have to cycle through the links and generate an object which relates the CustomNames to the link ids
                // This loop has to screen if the CustomName is already included as an object key and if so SKIP it because all twin/triplicate links should have duplicated streamProp objects
                let stream_Register = {}
                let graph_Links = graph.getLinks();
                let existing_Stream_Properties = [];
                for (let i = 0; i < graph_Links.length; i++) {
                    if ((graph_Links[i].attributes.CustomName) && (graph_Links[i].attributes.CustomName != '')) {
                        if (!(Object.keys(stream_Register)).includes(graph_Links[i].attributes.CustomName)) {
                            stream_Register[graph_Links[i].attributes.CustomName] = graph_Links[i].id
                            try {
                                let stream_Properties = graph_Links[i].attributes['complete_Stream_Properties']['massFlow']
                                let listed_Stream_Properties = Object.keys(stream_Properties)
                                for (let x = 0; x < listed_Stream_Properties.length; x++) {
                                    let prop = listed_Stream_Properties[x]

                                    let extended_Prop = prop + ' (' + 'tpd' + ')'

                                    if (!(existing_Stream_Properties.includes(extended_Prop))) {
                                        existing_Stream_Properties.push(extended_Prop)
                                    }

                                }
                            }
                            catch (e) {
                                if (e instanceof TypeError) {
                                    //
                                }
                            }
                        }
                    }
                }

                // After this is done,and the CustomNames (keys) are to be exported to an array and sorted in ascending numerical order
                let stream_Number_List = Object.keys(stream_Register).sort((a, b) => a - b)
                // This list can then be used to generate the columns!
                // Then we need a loop that goes through all the unique properties, starting with description
                // I imagine to get this we cycle through the links and append property name keys to an array
                // This again needs to screen against already included properties in the array
                //  columns can be populated using the addRow command on the keys-> using try/excepts for missing properties

                let equipment_List = []
                let graph_Elements = graph.getElements();
                let existing_Equipment_Properties = [];
                for (let i = 0; i < graph_Elements.length; i++) {
                    if (graph_Elements[i].prop('isUnit') == 'yes') {
                        equipment_List.push([graph_Elements[i].id])
                        try {
                            let equipment_Properties = graph_Elements[i].attributes['equipment_Properties']
                            let listed_Equipment_Properties = Object.keys(equipment_Properties)
                            for (let x = 0; x < listed_Equipment_Properties.length; x++) {
                                let prop = listed_Equipment_Properties[x]
                                let extended_Prop = prop
                                if (graph_Elements[i].attributes['equipment_Properties'][prop]['Units'] != '') { extended_Prop = prop + ' (' + graph_Elements[i].attributes['equipment_Properties'][prop]['Units'] + ')' }

                                if (!(existing_Equipment_Properties.includes(extended_Prop))) {
                                    existing_Equipment_Properties.push(extended_Prop)

                                }
                            }
                        }
                        catch (e) {
                            if (e instanceof TypeError) {
                                //
                            }
                        }
                    }
                }

                var workbook = new ExcelJS.Workbook();

                workbook.creator = 'FloWire';
                workbook.lastModifiedBy = 'Lewi';
                workbook.created = new Date();
                workbook.modified = new Date();
                workbook.lastPrinted = new Date();

                var streamsheet = workbook.addWorksheet("Streamtable");
                streamsheet.views = [
                    { state: 'frozen', xSplit: 0, ySplit: 1 }
                ];

                let excel_Column_Array = [{ header: 'Properties', key: 'properties', width: 25 }]
                //{ header: 'Journal/Conference', key: 'jc', width: 25, style: { alignment: { wrapText: true } } },
                //streamsheet.columns = ['']
                for (let i = 0; i < stream_Number_List.length; i++) {
                    excel_Column_Array.push({ header: 'S-' + stream_Number_List[i], key: stream_Register[stream_Number_List[i]] })
                }

                streamsheet.columns = excel_Column_Array;
                var firstRow = streamsheet.getRow(1);
                firstRow.font = { name: 'New Times Roman', family: 4, size: 10, bold: true };
                firstRow.alignment = { vertical: 'middle', horizontal: 'center' };
                firstRow.height = 20;

                for (let i = 0; i < existing_Stream_Properties.length; i++) {
                    let excel_Property_Object = {}
                    // Go through streams to fill out the key values
                    excel_Property_Object['properties'] = existing_Stream_Properties[i]
                    for (let x = 0; x < stream_Number_List.length; x++) {
                        let stream_Key = stream_Register[stream_Number_List[x]]
                        if ((graph.getCell(stream_Key).attributes.complete_Stream_Properties)) {
                            let stream_Property_Keys = Object.keys(graph.getCell(stream_Key).attributes.complete_Stream_Properties.massFlow)
                            for (let y = 0; y < stream_Property_Keys.length; y++) {
                                let extended_Stream_Prop_Name = stream_Property_Keys[y] + ' (tpd)'
                                if (extended_Stream_Prop_Name == existing_Stream_Properties[i]) {
                                    excel_Property_Object[stream_Key] = graph.getCell(stream_Key).attributes.complete_Stream_Properties.massFlow[stream_Property_Keys[y]]
                                }
                            }
                        }
                    }
                    streamsheet.addRow(excel_Property_Object)
                }

                let excel_Property_Object = {}
                excel_Property_Object['properties'] = 'Total Mass Flow (tpd)'
                for (let i = 0; i < graph_Links.length; i++) {
                    let totalMassFlow = graph_Links[i].attributes.complete_Stream_Properties.totalFlow
                    if (totalMassFlow) {
                        excel_Property_Object[graph_Links[i].id] = totalMassFlow
                    }
                }
                streamsheet.addRow(excel_Property_Object)


                var equipmentsheet = workbook.addWorksheet("Equipment")
                equipmentsheet.views = [
                    { state: 'frozen', xSplit: 0, ySplit: 1 }
                ];

                // Change the excel_Column_Array_2 to include all equipment properties
                // Set up the Equipment sheet columns with Unit No. column first
                // Set up the Equipment sheet columns with Unit No., Equipment, Input Streams, and Output Streams
                let excel_Column_Array_2 = [
                    { header: 'Unit No.', key: 'unitNo', width: 15 },
                    { header: 'Equipment', key: 'yAxis', width: 25 },
                    { header: 'Input Streams', key: 'inputStreams', width: 20 },
                    { header: 'Output Streams', key: 'outputStreams', width: 20 } // Added Output Streams column
                ];

                // Create equipment data rows with sequential unit numbers
                let dataRows = [];
                let unitCounter = 1; // Initialize counter for unit numbering

                for (let i = 0; i < equipment_List.length; i++) {
                    let equipmentCell = graph.getCell(equipment_List[i][0]);
                    
                    // Skip feed and product units if needed
                    if (equipmentCell.prop('unitType') === 'Feed' || equipmentCell.prop('unitType') === 'Product' || equipmentCell.prop('unitType') === 'pipework') {
                        continue;
                    }
                    
                    // Get equipment name
                    var header_Name = equipmentCell.prop('unitType');
                    if (equipmentCell.attr('shapename/innerHTML')) {
                        let label_Text = equipmentCell.attr('shapename/innerHTML').replace(/<[^>]+>/g, '');
                        if (label_Text !== '') {
                            header_Name = label_Text;
                        }
                    }
                    
                    // Create row object with unit number and equipment name
                    let rowData = { 
                        unitNo: unitCounter++, 
                        yAxis: header_Name
                    };
                    
                    // Add inputStreams property value
                    try {
                        if (equipmentCell.attributes.equipment_Properties && 
                            equipmentCell.attributes.equipment_Properties.inputStreams) {
                            
                            // Get streams in value directly
                            rowData.inputStreams = equipmentCell.attributes.equipment_Properties.inputStreams;
                        } else {
                            rowData.inputStreams = '';
                        }
                    } catch (e) {
                        console.log(`Error accessing inputStreams for equipment ${header_Name}:`, e);
                        rowData.inputStreams = '';
                    }
                    
                    // Add outputStreams property value
                    try {
                        if (equipmentCell.attributes.equipment_Properties && 
                            equipmentCell.attributes.equipment_Properties.outputStreams) {
                            
                            // Get streams out value directly
                            rowData.outputStreams = equipmentCell.attributes.equipment_Properties.outputStreams;
                        } else {
                            rowData.outputStreams = '';
                        }
                    } catch (e) {
                        console.log(`Error accessing outputStreams for equipment ${header_Name}:`, e);
                        rowData.outputStreams = '';
                    }
                    
                    dataRows.push(rowData);
                }

                equipmentsheet.columns = excel_Column_Array_2;
                equipmentsheet.addRows(dataRows);


                var TopRow = equipmentsheet.getRow(1);
                TopRow.font = { name: 'New Times Roman', family: 4, size: 10, bold: true };
                TopRow.alignment = { vertical: 'middle', horizontal: 'center' };
                TopRow.height = 20;


                // CHEMICALS SHEET
                var chemicalSheet = workbook.addWorksheet("Chemicals")
                chemicalSheet.views = [
                    { state: 'frozen', xSplit: 0, ySplit: 1 }
                ];


                // Update column headers to include Yearly Subtotal
                let excel_Column_Array_3 = [
                    { header: 'Chemicals', key: 'chemical', width: 20 },
                    { header: 'Quantity (TPD)', key: 'quantity', width: 15 },
                    { header: 'Cost (USD/ton)', key: 'cost', width: 15 },
                    { header: 'Daily Subtotal (USD)', key: 'dailySubtotal', width: 25 },
                    { header: 'Yearly Subtotal (USD)', key: 'yearlySubtotal', width: 25 }
                ];

                // Create arrays to store chemical data
                let chemicalDataRows = [];
                let chemicalNames = [];
                let totalDailySubtotal = 0;
                let totalYearlySubtotal = 0;

                // Only collect chemicals from feed units and their connected streams
                let feedChemicals = new Set();
                let chemicalCosts = {};
                let chemicalQuantities = {};
                let processedStreams = new Set(); // Track processed streams to avoid duplicates

                // Track feed units with "total feed" selected
                let totalFeedUnits = {};

                // Keep track of water contributions by stream
                let waterContributions = {};
                let totalWaterQuantity = 0;

                for (let i = 0; i < graph.getCells().length; i++) {
                    let cell = graph.getCells()[i];
                    if (cell.attributes.type == "pfd.FeedObject") {
                        // Get the feed unit name from the quill object
                        let feedName = "Feed Unit " + (i+1);
                        
                        // Try to get the name from shapename/innerHTML if available
                        if (cell.attr('shapename/innerHTML')) {
                            let labelText = cell.attr('shapename/innerHTML').replace(/<[^>]+>/g, '');
                            if (labelText.trim() !== '') {
                                feedName = labelText.trim();
                            }
                        }
                        
                        
                        // Check if this feed has a selected chemical in the dropdown
                        let selectedFeedChemical = null;
                        let isTotalFeed = false;
                        
                        if (cell.attributes.equipment_Properties && 
                            cell.attributes.equipment_Properties.selectedFeedDropDownValue) {
                            selectedFeedChemical = cell.attributes.equipment_Properties.selectedFeedDropDownValue;
                            
                            // Check if "total feed" is selected
                            if (selectedFeedChemical.toLowerCase() === "total feed") {
                                isTotalFeed = true;
                                // Store the feed unit cost if available
                                if (cell.attributes.equipment_Economics && 
                                    cell.attributes.equipment_Economics.Cost && 
                                    cell.attributes.equipment_Economics.Cost.Value) {
                                    
                                    let costValue = parseFloat(cell.attributes.equipment_Economics.Cost.Value) || 0;
                                    totalFeedUnits[feedName] = {
                                        cost: costValue,
                                        quantity: 0 // Will be updated later with total flow
                                    };
                                }
                            }
                        } else {
                            continue; // Skip processing if no chemical selected
                        }
                        
                        // Get the streams connected to this feed unit
                        let linkedStreams = graph.getConnectedLinks(cell);

                        
                        // Filter for only outgoing streams from feed units
                        let outgoingStreams = linkedStreams.filter(stream => 
                            stream.get('source').id === cell.id
                        );
                        
                        
                        for (let j = 0; j < outgoingStreams.length; j++) {
                            let stream = outgoingStreams[j];
                            let streamName = stream.attributes.CustomName || stream.id;
                            
                            // Skip if we've already processed this stream
                            if (processedStreams.has(stream.id)) {
                                continue;
                            }
                            processedStreams.add(stream.id);
                            
                            if (stream.attributes['complete_Stream_Properties'] && 
                                stream.attributes['complete_Stream_Properties']['totalFlow']) {
                                
                                let totalFlow = parseFloat(stream.attributes['complete_Stream_Properties']['totalFlow']) || 0;
                                
                                // If this feed unit has a "total feed" selection, update its quantity
                                if (isTotalFeed && totalFeedUnits[feedName]) {
                                    totalFeedUnits[feedName].quantity += totalFlow;
                                    continue;
                                }
                                
                                // For specific chemical selection, only include the selected chemical
                                if (!isTotalFeed && selectedFeedChemical && 
                                    stream.attributes['complete_Stream_Properties']['massFrac'] && 
                                    stream.attributes['complete_Stream_Properties']['massFrac'][selectedFeedChemical]) {
                                    
                                    let stream_Properties = stream.attributes['complete_Stream_Properties']['massFrac'];
                                    let massFraction = parseFloat(stream_Properties[selectedFeedChemical]) || 0;
                                    let chemicalQuantity = massFraction * totalFlow;
                                    
                                    // Add the chemical to our set of chemicals
                                    feedChemicals.add(selectedFeedChemical);
                                    
                                    // Add to the total quantity for this chemical
                                    if (!chemicalQuantities[selectedFeedChemical]) {
                                        chemicalQuantities[selectedFeedChemical] = 0;
                                    }
                                    
                                    chemicalQuantities[selectedFeedChemical] += chemicalQuantity;

                                    // Set the cost for this chemical if not already set
                                    if (!chemicalCosts[selectedFeedChemical] &&
                                        cell.attributes.equipment_Economics && 
                                        cell.attributes.equipment_Economics.Cost && 
                                        cell.attributes.equipment_Economics.Cost.Value) {
                                        
                                        let costValue = parseFloat(cell.attributes.equipment_Economics.Cost.Value) || 0;
                                        chemicalCosts[selectedFeedChemical] = costValue;
                                    }

                                } 
                            } 
                        }
                    }
                }


                // Convert Set to Array
                chemicalNames = Array.from(feedChemicals);

                // Calculate subtotals correctly
                totalDailySubtotal = 0;
                totalYearlySubtotal = 0;

                // Create data rows for the chemical sheet with subtotals
                for (let i = 0; i < chemicalNames.length; i++) {
                    let chemical = chemicalNames[i];
                    let quantity = chemicalQuantities[chemical] || 0;
                    let cost = chemicalCosts[chemical] || 0;
                    let dailySubtotal = quantity * cost;
                    let yearlySubtotal = (dailySubtotal / 24) * 8000; // Convert daily to yearly
                    
                    totalDailySubtotal += dailySubtotal;
                    totalYearlySubtotal += yearlySubtotal;
                    
                    let row = {
                        chemical: chemical,
                        quantity: quantity,
                        cost: cost,
                        dailySubtotal: dailySubtotal,
                        yearlySubtotal: yearlySubtotal
                    };
                    
                    chemicalDataRows.push(row);
                }

                // Add total feed units as rows
                Object.keys(totalFeedUnits).forEach(feedName => {
                    let feed = totalFeedUnits[feedName];
                    let dailySubtotal = feed.quantity * feed.cost;
                    let yearlySubtotal = (dailySubtotal / 24) * 8000;
                    
                    totalDailySubtotal += dailySubtotal;
                    totalYearlySubtotal += yearlySubtotal;
                    
                    let row = {
                        chemical: `Total feed unit: ${feedName}`,
                        quantity: feed.quantity,
                        cost: feed.cost,
                        dailySubtotal: dailySubtotal,
                        yearlySubtotal: yearlySubtotal
                    };
                    
                    chemicalDataRows.push(row);
                });

                // Add total row at the end
                chemicalDataRows.push({
                    chemical: 'Total',
                    quantity: '',
                    cost: '',
                    dailySubtotal: totalDailySubtotal,
                    yearlySubtotal: totalYearlySubtotal
                });

                // Add rows to the chemical sheet
                chemicalSheet.columns = excel_Column_Array_3;
                chemicalSheet.addRows(chemicalDataRows);

                // Style the header row
                var headerRow = chemicalSheet.getRow(1);
                headerRow.font = { name: 'New Times Roman', family: 4, size: 10, bold: true };
                headerRow.alignment = { vertical: 'middle', horizontal: 'center' };
                headerRow.height = 20;

                // Format cells - align numbers to right and set currency format
                for (let i = 2; i <= chemicalDataRows.length; i++) {
                    // Align all numeric cells to the right
                    chemicalSheet.getRow(i).getCell(2).alignment = { horizontal: 'right' };
                    chemicalSheet.getRow(i).getCell(3).alignment = { horizontal: 'right' };
                    chemicalSheet.getRow(i).getCell(4).alignment = { horizontal: 'right' };
                    chemicalSheet.getRow(i).getCell(5).alignment = { horizontal: 'right' };
                    
                    // Format cost and subtotal columns as currency
                    chemicalSheet.getRow(i).getCell(3).numFmt = '"$"#,##0.00';
                    chemicalSheet.getRow(i).getCell(4).numFmt = '"$"#,##0.00';
                    chemicalSheet.getRow(i).getCell(5).numFmt = '"$"#,##0.00';
                }

                // After adding all rows to the chemical sheet, fix the formatting for the total row
                // Get direct reference to the last row (Total row)
                let totalRow = chemicalSheet.getRow(chemicalSheet.rowCount);
                totalRow.getCell(1).font = { bold: true }; // "Total" text in column A
                totalRow.getCell(4).font = { bold: true, underline: 'double' }; // Daily subtotal value in column D
                totalRow.getCell(5).font = { bold: true, underline: 'double' }; // Yearly subtotal value in column E

                // Make sure both total values are formatted as currency
                totalRow.getCell(4).numFmt = '"$"#,##0.00';
                totalRow.getCell(5).numFmt = '"$"#,##0.00';
            
                // Create a combined Costing Estimate worksheet
                var costingSheet = workbook.addWorksheet("Costing Estimate");
                costingSheet.views = [
                    { state: 'frozen', xSplit: 0, ySplit: 1 }
                ];

                // Set up the columns for the enhanced costing worksheet
                let costingColumns = [
                    { header: 'Unit No.', key: 'unitNo', width: 10 },
                    { header: 'Equipment', key: 'equipment', width: 25 },
                    { header: 'Equipment CAPEX (USD)', key: 'capex', width: 18 },
                    { header: 'Installation CAPEX (USD)', key: 'installCapex', width: 20 },
                    { header: 'Additional CAPEX (USD)', key: 'additionalCapex', width: 20 },
                    { header: 'Total CAPEX (USD)', key: 'totalCapex', width: 18 },
                    { header: 'Maintenance (USD/yr)', key: 'maintenance', width: 18 },
                    { header: 'Utility (USD/yr)', key: 'utility', width: 15 },
                    { header: 'Labor (USD/yr)', key: 'labor', width: 15 },
                    { header: 'Total OPEX (USD/yr)', key: 'opex', width: 18 },
                    { header: 'Duty (kW)', key: 'duty', width: 15 }
                ];

                costingSheet.columns = costingColumns;

                // Style the header row
                var costingHeaderRow = costingSheet.getRow(1);
                costingHeaderRow.font = { name: 'New Times Roman', family: 4, size: 10, bold: true };
                costingHeaderRow.alignment = { vertical: 'middle', horizontal: 'center' };
                costingHeaderRow.height = 20;

                // Prepare to collect the equipment data
                let costingData = [];
                let costingUnitCounter = 1; // For sequential numbering in costing sheet

                // Collect data for all equipment units
                for (let i = 0; i < equipment_List.length; i++) {
                    let equipmentId = equipment_List[i][0];
                    let equipmentCell = graph.getCell(equipmentId);
                    
                    // Skip feed and product units
                    if (equipmentCell.prop('unitType') === 'Feed' || equipmentCell.prop('unitType') === 'Product' || equipmentCell.prop('unitType') === 'pipework') {
                        continue;
                    }
                    
                    // Get equipment name
                    let equipmentName = equipmentCell.prop('unitType');
                    if (equipmentCell.attr('shapename/innerHTML')) {
                        let labelText = equipmentCell.attr('shapename/innerHTML').replace(/<[^>]+>/g, '');
                        if (labelText !== '') {
                            equipmentName = labelText;
                        }
                    }
                    
                    // Get CAPEX value if available
                    let capexValue = "-";
                    if (equipmentCell.attributes['equipment_Economics'] && 
                        equipmentCell.attributes['equipment_Economics']['Capex'] && 
                        equipmentCell.attributes['equipment_Economics']['Capex']['Value'] !== undefined) {
                        capexValue = parseFloat(equipmentCell.attributes['equipment_Economics']['Capex']['Value']);
                    }
                    
                    // Get OPEX value if available
                    let opexValue = "-";
                    if (equipmentCell.attributes['equipment_Economics'] && 
                        equipmentCell.attributes['equipment_Economics']['Opex'] && 
                        equipmentCell.attributes['equipment_Economics']['Opex']['Value'] !== undefined) {
                        opexValue = parseFloat(equipmentCell.attributes['equipment_Economics']['Opex']['Value']);
                    }

                    let dutyValue = "-"; 
                    if (equipmentCell.attributes['equipment_Economics'] && 
                        equipmentCell.attributes['equipment_Economics']['Duty'] && 
                        equipmentCell.attributes['equipment_Economics']['Duty']['Value'] !== undefined) {
                        dutyValue = parseFloat(equipmentCell.attributes['equipment_Economics']['Duty']['Value']);
                    }
                    
                    let installCapexValue = "-";
                    let additionalCapexValue = "-";
                    let totalCapexValue = "-";
                    let maintenanceValue = "-";
                    let utilityValue = "-";
                    let laborValue = "-";

                    // Attempt to extract installation/additional CAPEX if available in the equipment attributes
                    if (equipmentCell.attributes['equipment_Economics'] && 
                        equipmentCell.attributes['equipment_Economics']['InstallCapex'] && 
                        equipmentCell.attributes['equipment_Economics']['InstallCapex']['Value'] !== undefined) {
                        installCapexValue = parseFloat(equipmentCell.attributes['equipment_Economics']['InstallCapex']['Value']);
                    }

                    if (equipmentCell.attributes['equipment_Economics'] && 
                        equipmentCell.attributes['equipment_Economics']['AdditionalCapex'] && 
                        equipmentCell.attributes['equipment_Economics']['AdditionalCapex']['Value'] !== undefined) {
                        additionalCapexValue = parseFloat(equipmentCell.attributes['equipment_Economics']['AdditionalCapex']['Value']);
                    }

                    if (equipmentCell.attributes['equipment_Economics'] && 
                        equipmentCell.attributes['equipment_Economics']['TotalCapex'] && 
                        equipmentCell.attributes['equipment_Economics']['TotalCapex']['Value'] !== undefined) {
                        totalCapexValue = parseFloat(equipmentCell.attributes['equipment_Economics']['TotalCapex']['Value']);
                    }

                    // Attempt to extract detailed OPEX values if available
                    if (equipmentCell.attributes['equipment_Economics'] && 
                        equipmentCell.attributes['equipment_Economics']['Maintenance'] && 
                        equipmentCell.attributes['equipment_Economics']['Maintenance']['Value'] !== undefined) {
                        maintenanceValue = parseFloat(equipmentCell.attributes['equipment_Economics']['Maintenance']['Value']);
                    }

                    if (equipmentCell.attributes['equipment_Economics'] && 
                        equipmentCell.attributes['equipment_Economics']['Utility'] && 
                        equipmentCell.attributes['equipment_Economics']['Utility']['Value'] !== undefined) {
                        utilityValue = parseFloat(equipmentCell.attributes['equipment_Economics']['Utility']['Value']);
                    }

                    if (equipmentCell.attributes['equipment_Economics'] && 
                        equipmentCell.attributes['equipment_Economics']['Labor'] && 
                        equipmentCell.attributes['equipment_Economics']['Labor']['Value'] !== undefined) {
                        laborValue = parseFloat(equipmentCell.attributes['equipment_Economics']['Labor']['Value']);
                    }

                    // Create row data with all columns
                    let rowData = {
                        unitNo: costingUnitCounter++,
                        equipment: equipmentName,
                        capex: capexValue,
                        installCapex: installCapexValue,
                        additionalCapex: additionalCapexValue,
                        totalCapex: totalCapexValue,
                        maintenance: maintenanceValue,
                        utility: utilityValue,
                        labor: laborValue,
                        opex: opexValue,
                        duty: dutyValue
                    };
                    
                    costingData.push(rowData);
                }

                // Calculate totals
                let totalEquipmentCapex = 0;
                let totalInstallCapex = 0;
                let totalAdditionalCapex = 0;
                let totalEquipmentTotalCapex = 0;
                let totalMaintenance = 0;
                let totalUtility = 0;
                let totalLabor = 0;
                let totalEquipmentOpex = 0;
                let totalEquipmentDuty = 0;

                costingData.forEach(row => {
                    // Add to totals only if values are numbers
                    if (typeof row.capex === 'number') totalEquipmentCapex += row.capex;
                    if (typeof row.installCapex === 'number') totalInstallCapex += row.installCapex;
                    if (typeof row.additionalCapex === 'number') totalAdditionalCapex += row.additionalCapex;
                    if (typeof row.totalCapex === 'number') totalEquipmentTotalCapex += row.totalCapex;
                    if (typeof row.maintenance === 'number') totalMaintenance += row.maintenance;
                    if (typeof row.utility === 'number') totalUtility += row.utility;
                    if (typeof row.labor === 'number') totalLabor += row.labor;
                    if (typeof row.opex === 'number') totalEquipmentOpex += row.opex;
                    if (typeof row.duty === 'number') totalEquipmentDuty += row.duty;
                });

                // Add totals row
                costingData.push({
                    unitNo: '',
                    equipment: 'TOTAL',
                    capex: totalEquipmentCapex,
                    installCapex: totalInstallCapex,
                    additionalCapex: totalAdditionalCapex,
                    totalCapex: totalEquipmentTotalCapex,
                    maintenance: totalMaintenance,
                    utility: totalUtility,
                    labor: totalLabor,
                    opex: totalEquipmentOpex,
                    duty: totalEquipmentDuty
                });

                // Add rows to the sheet
                costingSheet.addRows(costingData);

                
                // Format cells
                for (let i = 2; i <= costingData.length + 1; i++) {
                    // Align all numeric cells to the right
                    for (let col = 3; col <= 11; col++) { // Columns 3-11 are numeric
                        costingSheet.getRow(i).getCell(col).alignment = { horizontal: 'right' };
                        
                        // Format all monetary values as currency except the duty column (col 11)
                        if (col < 11) {
                            costingSheet.getRow(i).getCell(col).numFmt = '"$"#,##0.00';
                       }
                    }
                   
                   // Format duty column
                   if (typeof costingSheet.getRow(i).getCell(11).value === 'number') {
                       costingSheet.getRow(i).getCell(11).numFmt = '#,##0.00" kW"';
                   }
                }

               // Style the totals row
               let totalRowIndex = costingData.length + 1;
               costingSheet.getRow(totalRowIndex).getCell(2).font = { bold: true }; // "TOTAL" text
               // Bold all numeric cells in the total row
               for (let col = 3; col <= 11; col++) {
                   costingSheet.getRow(totalRowIndex).getCell(col).font = { bold: true };
               }
              
               // Create Analysis worksheet with economic metrics
               var analysisSheet = workbook.addWorksheet("Analysis");
               analysisSheet.views = [
                   { state: 'frozen', xSplit: 0, ySplit: 1 }
               ];
               
               // Set up columns for Analysis sheet with proper widths
               let analysisColumns = [
                   { header: 'Metric', key: 'metric', width: 30 },
                   { header: 'Value', key: 'value', width: 20 },
                   { header: 'Unit', key: 'unit', width: 15 }
               ];
               
               analysisSheet.columns = analysisColumns;
               
               // Style the header row
               var analysisHeaderRow = analysisSheet.getRow(1);
               analysisHeaderRow.font = { name: 'New Times Roman', family: 4, size: 10, bold: true };
               analysisHeaderRow.alignment = { vertical: 'middle', horizontal: 'center' };
               analysisHeaderRow.height = 20;
               
               // Use the directly passed econVars for the most accurate data
               // Use a fallback to graph.toJSON() if econVars isn't passed
               const econData = econVars || graph.toJSON();

               console.log("feedCostSumAnnual", econData.feedCostSumAnnual);
               
               // Add section headers with groups of metrics using the layout from the image
               // First, we'll create an array of all metrics organized by section
               const metricsWithSections = [
                   // Section 1: FINANCIAL PERFORMANCE METRICS
                   { section: 'FINANCIAL PERFORMANCE METRICS' },
                   { metric: 'Net Present Value (NPV)', value: econData.npvCalculated ?? "-", unit: 'USD' },
                   { metric: 'Levelized Cost of Product (LCOP)', value: econData.LCOP ? parseFloat(econData.LCOP) : "-", unit: 'USD/ton' },
                   { metric: 'Economic Potential', value: econData.economicPotential ?? "-", unit: 'USD/ton' },
                   { metric: 'Electricity Cost', value: econData.elecCost ?? "-", unit: 'USD/kWh' },
                   { metric: 'Project Lifetime', value: econData.years ?? "-", unit: 'years' },
                   { metric: 'Interest Rate', value: econData.interestRate ? (econData.interestRate * 100) : "-", unit: '%' },
                   
                   // Section 2: COST & REVENUE BREAKDOWN
                   { section: 'CAPEX BREAKDOWN' },
                   { metric: 'Total CAPEX', value: econData.totalCapex ?? "-", unit: 'USD' },
                   { metric: '  Equipment CAPEX', value: econData.equipmentCapex ?? "-", unit: 'USD' },
                   { metric: '  Installation Costs', value: econData.installationCosts ?? "-", unit: 'USD' },
                   { metric: '    Lang Factor', value: econData.langFactor ?? "-", unit: '' },
                   { metric: '    Material Factor', value: econData.materialFactor ?? "-", unit: '' },
                   { metric: '    Location Factor', value: econData.locationFactor ?? "-", unit: '' },
                   { metric: '  Additional CAPEX', value: econData.additionalCapex ?? "-", unit: 'USD' },
                   
                   // Section 3: PROJECT PARAMETERS
                   { section: 'PROJECT PARAMETERS' },
                   { metric: 'Total OPEX', value: econData.totalOpexDisplay ?? "-", unit: 'USD/year' },
                   { metric: '  Total Feedstock Cost', value: econData.feedCostSumAnnual ?? "-", unit: 'USD/year' },
                   { metric: '  Utility Costs', value: econData.utilityCosts ?? "-", unit: 'USD/year' },
                   { metric: '  Labor Costs', value: econData.laborCosts ?? "-", unit: 'USD/year' },
                   { metric: '    Operator Count', value: econData.operatorCount ?? "-", unit: 'people' },
                   { metric: '    Operator Salary', value: econData.operatorSalary ?? "-", unit: 'USD' },
                   { metric: '    Operator Benefits Base', value: econData.operatorBenefitsBase ?? "-", unit: 'USD' },
                   { metric: '    Benefits Percentage', value: econData.benefitsPercent ?? "-", unit: '%' },
                   { metric: '    Labor Overhead Factor', value: econData.laborOverheadFactor ?? "-", unit: '' },
                   { metric: '  Maintenance Costs', value: econData.maintenanceCosts ?? "-", unit: 'USD/year' },
                   { metric: '    Maintenance Rate', value: econData.maintenanceRate ?? "-", unit: '' },
                   { metric: '  Land Rent & Property Tax', value: econData.landRentandPropertyTax ?? "-", unit: 'USD/year' },
                   { metric: '    Land Rent', value: econData.landRent ?? "-", unit: '' },
                   { metric: '    Property Tax Insurance', value: econData.propertyTaxInsurance ?? "-", unit: '' },
                   { metric: '  Environmental Costs', value: econData.environmentalCosts ?? "-", unit: 'USD/year' },
                   { metric: '  Additional OPEX', value: econData.additionalOpex ?? "-", unit: 'USD/year' },
                   { metric: 'Total Product Revenue', value: econData.productRevAnnual ?? "-", unit: 'USD/year' },
                   { metric: 'Additional Revenue', value: econData.additionalRevenueAnnual ?? "-", unit: 'USD/year' },
                   { metric: 'Total Duty', value: econData.dutySum ?? "-", unit: 'kW' }
               ];

               // Now we'll add these to the sheet with proper formatting for sections
               let currentRow = 1;

               metricsWithSections.forEach(item => {
                   if (item.section) {
                       // This is a section header
                       currentRow++;
                       const sectionRow = analysisSheet.getRow(currentRow);
                       sectionRow.getCell(1).value = item.section;
                       
                       // Merge cells for the section header (columns 1-3)
                       analysisSheet.mergeCells(`A${currentRow}:C${currentRow}`);
                       
                       // Style the section header with light gray background
                       sectionRow.fill = {
                           type: 'pattern',
                           pattern: 'solid',
                           fgColor: { argb: 'FFE6E6E6' }
                       };
                       
                       sectionRow.font = { bold: true };
                       sectionRow.alignment = { horizontal: 'center' };
                   } else {
                       // This is a metric row
                       currentRow++;
                       const dataRow = analysisSheet.getRow(currentRow);
                       dataRow.getCell(1).value = item.metric;
                       dataRow.getCell(2).value = item.value;
                       dataRow.getCell(3).value = item.unit;
                       
                       // Format the value cell based on the unit
                       if (item.value !== "-" && typeof item.value === 'number') {
                           if (item.unit.includes('USD')) {
                               dataRow.getCell(2).numFmt = '"$"#,##0.00';
                           } else if (item.unit === '%') {
                               dataRow.getCell(2).numFmt = '0.00"%"';
                           } else {
                               dataRow.getCell(2).numFmt = '#,##0.00';
                           }
                       }
                       
                       // Align the value to the right
                       dataRow.getCell(2).alignment = { horizontal: 'right' };
                       
                       // Add borders
                       dataRow.border = {
                           bottom: { style: 'thin', color: { argb: 'FFE8E8E8' } }
                       };
                       
                       // Add indentation for sub-items
                       if (item.metric.startsWith('  ')) {
                           // This is a sub-item, add indentation
                           dataRow.getCell(1).indent = item.metric.startsWith('    ') ? 2 : 1;
                       }
                   }
               });

               // Check if discounted cash flow data is available
               if (econData.discountedCashflowCalculated && 
                   econData.discountedCashflowCalculated.length > 0 && 
                   econData.yearsTArray && 
                   econData.yearsTArray.length > 0) {
                   
                   // Add spacing
                   currentRow += 2;
                   
                   // Insert title for cash flow section
                   const cashFlowTitleRow = currentRow;
                   const titleRow = analysisSheet.getRow(cashFlowTitleRow);
                   titleRow.getCell(1).value = "NPV ANALYSIS";
                   analysisSheet.mergeCells(`A${cashFlowTitleRow}:C${cashFlowTitleRow}`);
                   
                   titleRow.font = { bold: true };
                   titleRow.fill = {
                       type: 'pattern',
                       pattern: 'solid',
                       fgColor: { argb: 'FFE6E6E6' }
                   };
                   titleRow.alignment = { horizontal: 'center' };
                   
                   // Add cash flow data
                   currentRow += 2;
                   const cashFlowHeaderRow = currentRow;
                   
                   // Add headers for cash flow table
                   analysisSheet.getRow(cashFlowHeaderRow).getCell(1).value = "Year";
                   analysisSheet.getRow(cashFlowHeaderRow).getCell(2).value = "Cumulative Discounted Cash Flow (USD)";
                   analysisSheet.getRow(cashFlowHeaderRow).font = { bold: true };
                   
                   // Add cash flow data rows
                   const years = econData.yearsTArray;
                   const cashflows = econData.discountedCashflowCalculated;
                   
                   for (let i = 0; i < years.length && i < cashflows.length; i++) {
                       currentRow++;
                       analysisSheet.getRow(currentRow).getCell(1).value = years[i];
                       analysisSheet.getRow(currentRow).getCell(2).value = cashflows[i];
                       // Format cash flow values as currency
                       analysisSheet.getRow(currentRow).getCell(2).numFmt = '"$"#,##0.00';
                       analysisSheet.getRow(currentRow).getCell(2).alignment = { horizontal: 'right' };
                   }
               }

               //=========== exports to excel ============ //

               var buff = workbook.xlsx.writeBuffer().then((data) => {
                   var blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
               
                   let d = new Date()
                   let ampm = d.getHours() >= 12 ? 'pm' : 'am';
                   var excel_name = graphName + ' ' + d.getDate() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + d.getFullYear() + ' ' + 
                                    String(d.getHours()).padStart(2, '0') + String(d.getMinutes()).padStart(2, '0') + ampm + '.xlsx';
                   saveAs(blob, excel_name);
               });
           }